import React from 'react';

import styled from 'styled-components';

export const Wrapper = styled.div<{ color: string; size }>`
  text-align: center;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: inline-block;
  animation: loading-rotate 1.4s linear infinite;

  svg {
    display: block;
  }

  circle {
    animation: loading-circle 1.4s ease-in-out infinite;
    stroke-dasharray: 80px, 200px;
    stroke-dashoffset: 0;
    stroke: ${({ color }) => color};
  }
`;
